export default __webpack_public_path__ + "images/angle-right_3535b05da1045c16e4e6541c7a00b411.svg";